let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("MLhYA")).then(() => parcelRequire('7wkkR'));